
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import homeTodayItem from "./components/home-today-item.vue";
import { echartsJS } from "@/common/add-js";
import { State } from "vuex-class";
import PiHomeAssetInfo from "./components/home-asset-info.vue";
import PiHomeRevenueCount from "./components/home-revenue-count.vue";
import HomeTomorrowData from "./components/home-tomorrow-data.vue";
import PiHomeTomorrowPower from "./components/home-tomorrow-power.vue";
import i18n from "@/config/i18n";
import {
  getHomeStatGunStatus,
  getHomeStatTodayElec,
  getHomeStatTodayOrders,
  getStaRanking
} from "@/api/api-operation-service";

@Component({
  components: {
    PiHomeAssetInfo,
    PiHomeRevenueCount,
    HomeTomorrowData,
    PiHomeTomorrowPower,
    homeTodayItem
  }
})
export default class PiHome extends Vue {
  @State("sys") sys!: objAny;

  private isEchart = false;

  //今日数据
  private toDayDataGunStatus: objAny = {
    title: i18n.t("home.gunStatus"),
    // smallTitle: "今日00:00-24:00充电枪状态",
    remark: "",
    unit: "",
    total: 0,
    aim: 4,
    color: [
      "#269A99",
      "#5AD8A6",
      "#E8684A",
      "#FF9D4D",
      "#5D7092",
      "#F6BD16",
      "#3399FF",
      "#9270CA",
      "#ff525d",
      "#54cbaf"
    ],
    list: []
  };
  private toDayDataElec: objAny = {
    title: i18n.t("home.todayDl"),
    smallTitle: i18n.t("home.todayDlTime"),
    remark: "",
    total: 0,
    aim: 2,
    color: ["#3399FF", "#5D7092", "#3b79c1", "#ff525d", "#54cbaf"],
    list: []
  };

  private toDayDataOrders: objAny = {
    title: i18n.t("home.todayOrder"),
    smallTitle: i18n.t("home.todayOrderTime"),
    total: 0,
    aim: 1,
    color: ["#3399FF", "#5AD8A6", "#F3B3A4", "#ff525d", "#54cbaf"],
    list: []
  };
  private tabs = [
    {
      label: i18n.t("today"),
      value: 1
    },
    {
      label: i18n.t("thisWeek"),
      value: 2
    },
    {
      label: i18n.t("thisMouth"),
      value: 3
    }
  ];
  private type = 1;

  public typeChange(value: number) {
    console.log(value);
    if (this.type === value) return;
    this.type = value;
    this.getToDayData();
  }

  private gunTimer = 0;
  public itemTotal(value: number) {
    const arr: string[] = value.toString().split(".");
    if (arr[1] && arr[1].length == 3) {
      return parseFloat(value.toFixed(3));
    } else if (arr[1] && arr[1].length == 0) {
      return value;
    } else {
      return parseFloat(value.toFixed(2));
    }
  }

  async getHomeStatTodayOrders(): Promise<void> {
    const ret = await getHomeStatTodayOrders({
      type: this.type
    });
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data || [];
      let total = 0;
      data.map((item: objAny) => {
        total = total + item.value;
      });

      this.toDayDataOrders.total = this.itemTotal(total);
      this.toDayDataOrders.list = data;
    }
  }

  async getHomeStatTodayElec(): Promise<void> {
    const params = {
      type: this.type
    };
    const ret = await getHomeStatTodayElec(params);
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data || [];
      let total = 0;
      data.map((item: objAny) => {
        total = total + item.value;
      });
      this.toDayDataElec.total = this.itemTotal(total);
      this.toDayDataElec.list = data;
    }
  }

  private timesList: objAny = [];
  private durationList: objAny = [];
  async getTimeList(chatType: number): Promise<void> {
    const ret = await getStaRanking({ topNum: 8, type: this.type, chatType });
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data || [];
      if (chatType === 1) {
        this.timesList = data;
      } else {
        this.durationList = data;
      }
    }
  }

  public getToDayData(): void {
    this.getHomeStatTodayElec();
    this.getHomeStatTodayOrders();
    this.getTimeList(1);
    this.getTimeList(2);
  }

  async getHomeStatGunStatus(timer?: boolean): Promise<void> {
    const ret = await getHomeStatGunStatus({});
    if (ret.status === this.$config.apiStatus) {
      const data = ret.data || [];
      let total = 0;
      data.map((item: objAny) => {
        total = total + item.value;
      });
      this.toDayDataGunStatus.total = this.itemTotal(total);
      this.toDayDataGunStatus.list = data;
    }
    if (timer) {
      this.gunTimer = setTimeout(() => {
        this.getHomeStatGunStatus(true);
      }, 10000);
    }
  }

  public formDataNull(data: objAny): objAny {
    const json: objAny = {};
    for (const i in data) {
      json[i] = data[i] == "" ? null : data[i];
    }
    return json;
  }

  async echartInit(): Promise<void> {
    await echartsJS();
    this.isEchart = true;
    this.getToDayData();
  }

  mounted() {
    this.getHomeStatGunStatus();
    this.echartInit();
  }
  destroyed() {
    clearTimeout(this.gunTimer);
  }
}
